// extracted by mini-css-extract-plugin
module.exports = {"spectrum-area":"_4aTb5","spectrum-parent":"_1gPvU","Flipped":"_25UrS","leftHead-div":"V7FNK","leftHead":"_1d7g8","v-stack":"_21HPv","h-stack":"_3DNLd","spectrum-grid":"_2KHcT"};